/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NcdClass } from './ncdClass';
import { Price } from './price';
import { NcdClassReason } from './ncdClassReason';

/**
 * Represents a motor vehicle liability insurance.   (german: Kfz Haftpflicht)   (bipro-kraftfahrt::KfzHaftpflichtVersicherung)
 */
export interface MotorVehicleLiabilityInsurance {
  /**
   * Technical discriminator for the concrete elementary product type.
   */
  productType: string;
  /**
   * Calculated prices for this product.  Currency is always euro and cent.   (german: Beitrag) (bipro-produktmodell::Beitrag)
   */
  prices?: Array<Price>;
  ncdClassLiability?: NcdClass;
  ncdClassReason?: NcdClassReason;
  /**
   * This avoids the downgrade of the NCD class in case of damages.   (german: Rabattretter, Nix-Passiert-Tarif)
   */
  ncdClassProtection?: boolean;
}
export namespace MotorVehicleLiabilityInsurance {}
